export default {
    user: null,    
    queryParams: null,
    isLogged: false,    
}